import styled from 'styled-components'

export const RemoveItemModalFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  button:first-of-type {
    margin-right: 16px;
  }
  padding-bottom: 16px;
`
export const RemoveItemModalText = styled.div`
  font-size: 16px;
  line-height: 24px;
  color: rgba(32, 32, 32, 0.7);
  text-align: center;
`
